import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsEditNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15.379 1.207a3 3 0 014.242 0l3.172 3.171a3 3 0 010 4.243l-13.5 13.5A3 3 0 017.172 23H3a2 2 0 01-2-2v-4.172a3 3 0 01.879-2.121zm6 6a1 1 0 000-1.414L18.207 2.62a1 1 0 00-1.414 0L15.414 4 20 8.585zm-17.223 8.05l3.669.918.917 3.669L18.586 10 14 5.414zM3 17.03V21h3.97l-.795-3.176z"
        fill=""
      />
    </svg>
  )
);
SvgActionsEditNormalSmall.defaultProps = {
  color: "currentColor",
  size: 24,
  title: undefined,
  titleId: undefined,
};
SvgActionsEditNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsEditNormalSmall;
